export const appRoutes = {
    mainPage: '/',
    about: 'about',
    prettyNums: 'krasivyie-nomera',
    goodTariffs: 'vygodnyie-tarify',
    drugomaniya: 'drugomaniya',
    history: 'history',
    myNumbers: 'my-numbers',
    profile: 'profile',
    help: 'help',
    loyaltyProgram: 'loyalty-program',
    settings: 'settings',
    myReservations: 'my-reservations',
    termsOfService: 'terms-of-service',
    privacyPolicy: 'privacy-policy',
};
